<template>
  <div>
    <div class="sidebar-right">
      <h1 class="modal-h1 mb-3">
        <button type="button"
                class="btn btn-back"
                @click="closeModal"
        />
        Customer info
      </h1>
      <div class="l-bg-white position-relative">
        <div class="row border-bottom pb-2 mb-3">
          <div class="col-md-6 px-1 mb-2">
            <div class="select-wrap">
              <label>Phone</label>
              <input v-model="data.customer.phone"
                     type="text"
                     class="form-control"
                     @keydown="maskPhone($event)"
                     :disabled="!$_can('companies.customers.update')"
                     :placeholder="'Enter Phone'" maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
          <div class="col-md-6 px-1 mb-2">
            <div class="select-wrap">
              <label>Email</label>
              <input v-model="data.customer.email"
                     type="text"
                     class="form-control"
                     :disabled="!$_can('companies.customers.update')"
                     placeholder="Enter Email"
              />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-md-6 px-1 mb-2">
            <div class="select-wrap">
              <label>First name</label>
              <input v-model="data.customer.first_name"
                     type="text"
                     class="form-control"
                     :disabled="!$_can('companies.customers.update')"
                     :placeholder="'Enter First Name'"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col-md-6 px-1 mb-2">
            <div class="select-wrap">
              <label>Last name</label>
              <input v-model="data.customer.last_name"
                     type="text"
                     class="form-control"
                     :disabled="!$_can('companies.customers.update')"
                     :placeholder="'Enter Last Name'"
              />
            </div>
            <error-field :errors="errors" field="last_name" />
          </div>
          <div v-if="leadId && !data.customer.mod_link_sent" class="col-md-12 check-field">
            <label for="make-mod"
                   :class="{'check-open' : data.customer.make_mod_customer === true}"
                   @click.prevent="changeModCustomer"
            ><span
              class="checkmark"
            /> Make this customer a Mod24 customer
              <input type="checkbox"
                     id="make-mod"
                     v-model="data.customer.make_mod_customer"
                     class="btn-check"
              />
            </label>
          </div>
        </div>
        <div class="row border-bottom pb-2 mb-3">
          <div class="col-md mb-3">
            <h4>Additional contacts</h4>
            <form @submit.prevent="submit" autocomplete="off">
              <div class="row mb-4"
                   v-for="(contact, index) in data.customer.contacts"
                   :key="index"
              >
                <div class="col-md-5 pl-1 pr-1">
                  <div class="select-wrap">
                    <label>Additional phone</label>
                    <input type="tel"
                           class="form-control"
                           v-model="contact.phone"
                           @keydown="maskPhone(index, $event)"
                           autocomplete="false"
                           :disabled="!$_can('companies.customers.update')"
                           placeholder="Enter Phone" maxlength="14"
                    />
                  </div>
                  <error-field :errors="errors" :field="`contacts.${index}.phone`" />
                </div>
                <div class="col-md-5 pl-1 pr-1">
                  <div class="select-wrap">
                    <label>Additional email</label>
                    <input type="email"
                           class="form-control"
                           placeholder="Enter Email"
                           v-model="contact.email"
                           autocomplete="false"
                           :disabled="!$_can('companies.customers.update')"
                           @keydown="clearError($event)"
                    />
                  </div>
                  <error-field :errors="errors" :field="`contacts.${index}.email`" />
                </div>
                <div class="col-md-1 pr-0 pl-5 pt-3 text-right">
                  <button type="button"
                          class="btn btn-clear p-1"
                          @click="removeContact(index)"
                          v-if="$_can('companies.customers.update')"
                  >
                    <span class="mod-icon-clear" />
                  </button>
                </div>
              </div>
              <button type="button"
                      class="btn add-button"
                      @click="addAdditionalContact"
                      v-if="$_can('companies.customers.update')"
              >
                <span><span class="mod-icon-add" /></span>
                Add additional contact
              </button>
            </form>
          </div>
        </div>
        <div class="row border-bottom pb-2 mb-3">
          <div class="col-md-12">
            <h4>Payment Info</h4>
            <payment :customer="data.customer"
                     :company="data.company"
                     :is-mod="isMod"
                     width="col-12"
                     @update="$emit('update')"
            />
          </div>
        </div>
        <div class="row"
             v-if="$_can('companies.customers.update')"
        >
          <div class="col-md-12 pr-0 text-right">
            <button type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
            >
              Cancel
            </button>
            <button type="button"
                    class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled || !isValid"
                    @click="editCustomer(data.customer.id)"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../classes/Errors';
import ErrorField from './ErrorField';
import Payment from './Payment';
import PhoneMask from '../classes/PhoneMask';

export default {
  components: {
    Payment,
    ErrorField,
  },
  props: {
    data: {
      type: Object,
      default: () => [],
    },
    leadId: {
      type: Number,
      default: null,
    },
    showCustomerModal: {
      type: Boolean,
      default: false,
    },
    claimId: {
      type: Number,
      default: null,
    },
    jobId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    phoneMask: new PhoneMask(),
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  computed: {
    isMod() {
      return this.data.source.name === 'Mod24';
    },
    isValid() {
      return (
        this.data.customer.first_name && (this.data.customer.phone || this.data.customer.email)
      );
    },
  },
  created() {
    this.$set(this.data.customer, 'phone', this.phoneMask.maskedPhone(this.data.customer.phone));
    this.data.customer.contacts.forEach(el => {
      const element = el;
      element.phone = this.phoneMask.maskedPhone(element.phone);
    });
  },
  updated() {
    this.data.customer.contacts.forEach(el => {
      const element = el;
      element.phone = this.phoneMask.maskedPhone(element.phone);
    });
  },
  methods: {
    changeModCustomer() {
      this.$swal({
        title: 'Are you sure?',
        text:
          'Changing this will update the customer, and reload the lead. Added cards for the Customer will no longer be available. All unsaved changes will be lost.',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then(result => {
        if (result.value) {
          this.data.customer.make_mod_customer = !this.data.customer.make_mod_customer;
          this.data.customer.company_id = this.data.customer.make_mod_customer
            ? null
            : this.data.company_id;
          this.editCustomer(this.data.customer.id);
        }
      });
    },
    clearError() {
      this.errors.clear();
    },
    closeModal() {
      if (this.isValid) {
        this.$emit('cancel');
      }
    },
    maskPhone(index, event) {
      this.$nextTick(() => {
        this.$set(
          this.data.customer,
          'phone',
          this.phoneMask.maskedPhone(this.data.customer.phone.replace(/\D/g, '')),
        );
        this.clearError(event);
      });
    },
    addAdditionalContact() {
      this.data.customer.contacts.push({
        email: '',
        phone: '',
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
      });
    },
    removeContact(index) {
      this.data.customer.contacts.splice(index, 1);
    },
    editCustomer(id) {
      if (this.isValid) {
        this.buttonDisabled = true;
        this.loadingButton = true;

        axios
          .put(`customers/${id}`, {
            ...this.data.customer,
            lead_id: this.leadId,
            claim_id: this.claimId,
            job_id: this.jobId,
          })
          .then(() => {
            this.$emit('update');
            toastr.success('Successfully edited customer');
            this.errors.clear();
            this.closeModal();
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
            this.data.customer.contacts.forEach(el => {
              const element = el;
              element.phone = this.phoneMask.maskedPhone(element.phone);
            });
          })
          .finally(() => {
            if (this.data.customer.contacts.email === '') {
              this.removeContact();
            }
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SideModalCustomerInfo.vue